/* eslint-disable no-undef */
// import "firebase/remote-config";
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { getRemoteConfig } from "firebase/remote-config";

import logging from "utils/logging";
const log = logging.getLogger("Firebase Utils");
log.setLevel('debug');


const ENV = process.env.REACT_APP_FIREBASE_ENV;
const IS_EMULATOR = ENV === "emulator";
const IS_STAGING = ENV === "staging";
const IS_PRODUCTION = ENV === "production";

let firestoreDB;
let firebaseAuth;
let firebaseFunctions;
let firebaseStorage;
let firebaseRemoteConfig;
const initialize = () => {

  log.info("ENV", ENV);
  log.debug("IS_EMULATOR", IS_EMULATOR);
  log.debug("IS_STAGING", IS_STAGING);
  log.debug("IS_PRODUCTION", IS_PRODUCTION);

  let config;

  config = {
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  }

  if (IS_EMULATOR) {
    log.debug("Using firebase emulator");
  } else if (IS_STAGING) {
    log.debug("Using firebase staging");
  } else if (IS_PRODUCTION) {
    log.debug("Using firebase production");
  }

  log.info("Using firebase config", config);

  const app = initializeApp(config);

  firestoreDB = getFirestore(app);
  firebaseAuth = getAuth(app);
  firebaseFunctions = getFunctions(app, 'us-central1');
  firebaseStorage = getStorage(app);
  firebaseRemoteConfig = getRemoteConfig(app);

  if (IS_EMULATOR) {
    // Auth Emulator
    if (process.env.REACT_APP_EMULATOR_AUTH_URL) {
      log.debug(`Using emulator for auth: ${process.env.REACT_APP_EMULATOR_AUTH_URL}`);
      try {
        connectAuthEmulator(firebaseAuth, process.env.REACT_APP_EMULATOR_AUTH_URL);
        log.debug("Auth emulator connection successful");
      } catch (error) {
        log.error("Error setting up Auth emulator:", error);
      }
    }

    // Firestore Emulator
    if (process.env.REACT_APP_FIRESTORE_EMULATOR_HOST) {

      const emulatorHost = process.env.REACT_APP_FIRESTORE_EMULATOR_HOST;
      const emulatorPort = parseInt(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT);

      log.debug(`Using emulator for firestore: ${emulatorHost}:${emulatorPort}`);
      try {
        connectFirestoreEmulator(firestoreDB, emulatorHost, emulatorPort);
        log.debug("Firestore emulator connection successful");
      } catch (error) {
        log.error("Error setting up Firestore emulator:", error);
      }
    }

    // Storage Emulator
    if (process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_HOST) {
      log.debug(`Using emulator for storage: ${process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_HOST}`);
      try {
        connectStorageEmulator(firebaseStorage, process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_HOST, parseInt(process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_PORT));
        log.debug("Storage emulator connection successful");
      } catch (error) {
        log.error("Error setting up Storage emulator:", error);
      }
    }

    if (process.env.REACT_APP_FIREBASE_FUNCTIONS_HOST) {
      const functionsHost = process.env.REACT_APP_FIREBASE_FUNCTIONS_HOST;
      const functionsPort = parseInt(process.env.REACT_APP_FIREBASE_FUNCTIONS_PORT);
      try { 
        connectFunctionsEmulator(firebaseFunctions, functionsHost, functionsPort);
        log.debug("Functions emulator connection successful");
      } catch (error) {
        log.error("Error setting up Functions emulator:", error);
        }

    }
  }
};

const firestore = () => firestoreDB;
const db = () => firestoreDB;
const remoteConfig = () => firebaseRemoteConfig;
const auth = () => firebaseAuth;
const storage = () => firebaseStorage;
const functions = () => firebaseFunctions;

const getCallableFunction = (name) => {
  return httpsCallable(firebaseFunctions, name);
}

function stopWatching(unsubscribe) {
  unsubscribe();
}

let api = {
  firestore,
  initialize,
  db,
  storage,
  remoteConfig,
  functions,
  getCallableFunction,
  auth,
  stopWatching,
};

export default api;
